export default {"src":"/_next/static/media/calender-icon.bcdf3d37.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};